export const settings = {
  siteName: "Projektpartner",
  siteUrl: "",
  email: "info@projektpartner.com",
  phone1: "0621 - 33 64 22 77",
  phone2: "0178 - 14 54 875",
  address: "Q1 17-18, 68161 Mannheim",
  mapUrl: "https://goo.gl/maps/xjM5DYqHRx4u1KH48",
  mapEmbedUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2591.8026442446526!2d8.465405515682216!3d49.488234879354174!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4797cc23822c702f%3A0xdaecfb4117bc57!2sQ1%2017%2C%2068161%20Mannheim!5e0!3m2!1sen!2sde!4v1676470698117!5m2!1sen!2sde",
};
